import { useContext } from "react";
import { UnsavedChangesContext } from "./UnsavedChanges";

export default function useUnsavedChangesContext() {
    return useContext(UnsavedChangesContext);
};
